import React, {Component} from "react"
import browserImageSize from "browser-image-size"

import ErrorText from "@irati/ui/src/ErrorText"
import Loading from "@irati/ui/src/Loading"
import add_a_file from "@irati/ui/images/add-a-file.png"
import getBase64 from "@irati/utils/images/getBase64"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import {uploadImage} from "@irati/images/services/image"
import Flex from "@irati/ui/src/Flex"
import {Body, Label} from "@irati/ui/src/Typography"

import {StyledDropzone, StyledFormGroup, StyledUploadIcon, UploadedImage} from "./styled"

interface Props extends InjectIntl {
  error?: string,
  help: string,
  imageUrl?: string,
  message: string,
  onUploadSuccess: (imageUrl: string) => void
}

interface State {
  load?: Promise<void>,
  uploadError?: string
}

class ImageUploader extends Component<Props, State> {
  state: State = {}

  handleUpload = (file: File) => {
    return uploadImage(file).then((uploadedImageURL: string) => {
      this.props.onUploadSuccess(uploadedImageURL)
    })
  }

  handleDrop = (acceptedFile: [File], rejectedFile: [File]) => {
    const {formatMessage} = this.props

    if (rejectedFile.length > 0) {
      return this.setState({
        uploadError: formatMessage({
          id: "platform.fields.imageUploader.dimensionsError"
        })
      })
    }
    const acceptedFileImage = acceptedFile[0]

    getBase64(acceptedFileImage).then((base64Image: any) => {
      const load = browserImageSize(base64Image).then(() => {
        return this.handleUpload(base64Image)
      })
      this.setState({load, uploadError: undefined})
    })
  }

  render() {
    const {error, imageUrl, help, message} = this.props
    const {load, uploadError} = this.state

    return (
      <StyledFormGroup>
        <StyledDropzone accept="image/jpg,image/jpeg,image/png" onDrop={this.handleDrop} hasError={!!error}>
          {load && (
            <Flex>
              <Loading load={load} />
            </Flex>
          )}

          {uploadError && <ErrorText>{uploadError}</ErrorText>}

          {!load && !uploadError && !imageUrl && (
            <>
              <StyledUploadIcon src={add_a_file} height={80} alt="add_a_file" />
              <Label display="block" marginBottom={1}>
                {message}
              </Label>
              <Body textAlign="center">{help}</Body>
            </>
          )}

          {imageUrl && <UploadedImage src={imageUrl} />}
        </StyledDropzone>
      </StyledFormGroup>
    )
  }
}

export default injectIntl(ImageUploader)
